import { ProjectStateReducerCreator } from '../types';

const clearPreviewTemplateReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state) => {
    state.previewTemplate = null;
  });
};

export default clearPreviewTemplateReducer;
